import {
    useRef,
    useState
} from 'react';

import {SimpleGrid, Text} from '@mantine/core';

import {useMeteringRecords} from '../hooks/useMeteringRecords.ts';
import {useMeteringRecordsSelection} from '../hooks/useMeteringRecordsSelection.ts';
import {FormDrawer} from '../drawers/FormDrawer.tsx';
import {update} from '../services/MeteringRecordsService.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableColumn} from "mantine-datatable";
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";
import {MeteringRecord} from '../types';
import {useQueryClient} from '@tanstack/react-query';

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useMeteringRecordsSelection();
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<MeteringRecord | null>(null);
    const queryClient = useQueryClient();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useMeteringRecords();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<MeteringRecord>[] = [
        {
            accessor: 'id',
            title: 'Record',
            render: (record: MeteringRecord) => (
                <Text c="blue" style={{cursor: 'pointer'}}>
                    {record.id}
                </Text>
            )
        },
        {accessor: 'created', title: 'Created'},
    ];

    const handleDrawerSubmit = async (values: MeteringRecord) => {
        if (selectedRecord?.id) {
            const {created: _created, updated: _updated, createdByUsername: _createdByUsername, createdBy: _createdBy, ...rest} = values;
            await update(selectedRecord.id, rest as MeteringRecord);
            queryClient.invalidateQueries({queryKey: ['metering-records']});
        }
    };

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                onRowClick={({record}) => {
                    setSelectedRecord(record);
                    setDrawerOpened(true);
                }}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>

            <FormDrawer
                record={selectedRecord || {} as MeteringRecord}
                handleSubmit={handleDrawerSubmit}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </SimpleGrid>
    );
};
